import React from 'react'
import EmployeeSelect from './EmployeeSelect'
import { compact, remove } from 'lodash'
import MultiSelect from './MultiSelect'
import { IEmployee } from '@api'
import { Avatar, Flex } from '@ui'
import { IUIButtonProps } from '@ui/buttons/Button'

interface MultiEmployeeSelectProps {
  values: IEmployee[]
  onChange: (items: IEmployee[], param?: any) => void
  noTitle?: boolean
  onClear?: () => void
  title?: string
  disabled?: boolean
  reselectAllItems?: boolean
}

export default function MultiEmployeeSelect({
  values,
  onChange,
  noTitle,
  onClear,
  title,
  disabled,
  reselectAllItems = true,
}: MultiEmployeeSelectProps) {
  const buttonProps: IUIButtonProps = {
    minimal: true,
    iconName: 'plus',
    blue: true,
    disabled,
  }

  const selectDeselectHandler = (employee: IEmployee | null) => {
    values.find(({ id }) => id === employee?.id)
      ? onChange(values.filter(({ id }) => id !== employee?.id))
      : onChange(employee ? [...values, employee] : values)
  }

  const reselectAllItemsHandler = (emp: IEmployee | null) => {
    emp && !!values.find((v) => v.id === emp.id)
      ? onChange(
          remove([...values], (i) => i.id === emp.id),
          { id: emp.id, status: 'remove' }
        )
      : onChange(compact([...values, emp]), { id: emp?.id, status: 'add' })
  }

  return (
    <MultiSelect
      title={title ? title : noTitle ? undefined : 'Employees'}
      values={values.map((employee) => (
        <Flex align="center" key={employee.id}>
          <div style={{ marginRight: 8, marginLeft: -12 }}>
            <Avatar
              size={Avatar.Size.XS}
              name={employee.name}
              assets={employee.assets}
              clickable={!disabled}
            />
          </div>
          {employee.name}
        </Flex>
      ))}
      select={
        !disabled && (
          <EmployeeSelect
            multi
            itemDisabled={(emp) => values.map((em) => em.id).includes(emp.id)}
            onChange={(emp) => {
              reselectAllItems ? reselectAllItemsHandler(emp) : selectDeselectHandler(emp)
            }}
            placeholder="Add"
            value={null}
            {...{ buttonProps }}
          />
        )
      }
      onRemove={(id) =>
        !disabled &&
        onChange(
          values.filter((emp) => emp.id !== id),
          { id, status: 'remove' }
        )
      }
      onClearAll={onClear}
    />
  )
}
